import {
  LSPAY_ERROR,
  LSPAY_ERROR_MESSAGES,
  PAIRING_ERROR,
  STRIPE_ERROR_CODE,
} from './lspayConstants'

export function getConnectionErrorMessage({
  error,
  pairingLabel = 'unnamed',
  paymentTypeName,
  isRefund,
}: {
  error: any
  pairingLabel?: string
  paymentTypeName: string
  isRefund?: boolean
}) {
  const code = error.code || error.error?.code || error.name

  const transactionType = isRefund ? 'refund' : 'payment'
  switch (code) {
    case STRIPE_ERROR_CODE.READER_ERROR:
      return {
        header: `This ${transactionType} can't be taken because the terminal "${pairingLabel}" isn't connected.`,
        body: `Please make sure the terminal is turned on and connected to the same wifi network as the register, then retry this ${transactionType}`,
      }
    case STRIPE_ERROR_CODE.FAILED_FETCH_CONNECTION_TOKEN:
    case PAIRING_ERROR:
      return {
        header: 'The register is not paired with a terminal.',
        body: `To take a ${transactionType} with "${paymentTypeName}", pair this register with a terminal in your payment type setup. To complete this sale choose another payment type.`,
      }
    default:
      return isRefund
        ? LSPAY_ERROR_MESSAGES[LSPAY_ERROR.DEFAULT_REFUND]
        : LSPAY_ERROR_MESSAGES[LSPAY_ERROR.DEFAULT_PAYMENT]
  }
}
